// src/components/chat/ChatRoomHeader.jsx
import React, { useState } from 'react';
import { Dropdown, Badge, Button } from 'react-bootstrap';
import { useChat } from '../../contexts/ChatContext';
import { useAuth } from '../../contexts/AuthContext';
import ChatAddParticipantModal from './ChatAddParticipantModal';
import ChatSettingsModal from './ChatSettingsModal';

const ChatRoomHeader = ({ room }) => {
  const { leaveRoom, addParticipant, removeParticipant } = useChat();
  const { user } = useAuth();
  const [showAddModal, setShowAddModal] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);

  const isAdmin = room.participants?.some(p => p.user_id === user?.id && p.role === 'admin');
  const isGroup = room.type === 'group';

  const getRoomIcon = () => {
    if (room.type === 'group') return 'bi-people';
    if (room.type === 'task') return 'bi-list-task';
    return 'bi-person';
  };

  const getRoomName = () => {
    if (room.type === 'group') return room.name || 'Группа';
    if (room.type === 'task') return `Задача #${room.task_id}`;
    const other = room.participants?.find(p => p.user_id !== user?.id);
    return other?.user_name || 'Диалог';
  };

  const handleLeave = async () => {
    if (window.confirm('Вы уверены, что хотите покинуть чат?')) {
      await leaveRoom(room.id);
    }
  };

  return (
    <div className="chat-room-header p-3 border-bottom bg-white d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center gap-2">
        <i className={`bi ${getRoomIcon()} fs-4`}></i>
        <div>
          <h6 className="mb-0">{getRoomName()}</h6>
          <small className="text-muted">
            {room.participants?.length} участников
            {room.is_locked && (
              <Badge bg="danger" className="ms-2">
                <i className="bi bi-lock me-1"></i>
                закрыт
              </Badge>
            )}
          </small>
        </div>
      </div>

      <Dropdown align="end">
        <Dropdown.Toggle variant="outline-secondary" size="sm" id="room-actions">
          <i className="bi bi-three-dots-vertical"></i>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {isGroup && isAdmin && (
            <>
              <Dropdown.Item onClick={() => setShowAddModal(true)}>
                <i className="bi bi-person-plus me-2"></i>
                Добавить участника
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setShowSettingsModal(true)}>
                <i className="bi bi-gear me-2"></i>
                Настройки группы
              </Dropdown.Item>
            </>
          )}
          {isGroup && (
            <Dropdown.Item onClick={handleLeave} className="text-danger">
              <i className="bi bi-box-arrow-right me-2"></i>
              Покинуть группу
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>

      <ChatAddParticipantModal
        show={showAddModal}
        onHide={() => setShowAddModal(false)}
        roomId={room.id}
        onParticipantAdded={() => setShowAddModal(false)}
      />
      <ChatSettingsModal
        show={showSettingsModal}
        onHide={() => setShowSettingsModal(false)}
        room={room}
      />
    </div>
  );
};

export default ChatRoomHeader;